'use client';

import { ThemeProvider } from '@mui/material';
import themeNew from 'ui/theme/themeNew';
import { getConsentPurposes, NO_PURCHASE, OTHER_COUNTRY } from 'onetrust/src';
import { GEOLOCATION_ALLOWED, X_GEO_LOCATION_STATUS } from 'utils';
import { getCookie } from 'cookies-next';
import RecipeModal from 'ui/components/recipeModal';
import { trackBrazeUser } from 'braze-react';
import postConsent from '../../../utils/onetrust/postConsent';

const delay = 60 * 1000;

export default function RecipeModalCaller({ brazeConfig, modalContent, shouldShowRecipeModal }) {
  // get geoLocationStatus: allowed, coming-soon, not-allowed
  const geoLocationStatus = getCookie(X_GEO_LOCATION_STATUS) || GEOLOCATION_ALLOWED;
  const collectionPoint = geoLocationStatus === GEOLOCATION_ALLOWED ? NO_PURCHASE : OTHER_COUNTRY;
  const consentPurposes = getConsentPurposes(brazeConfig.LINGO_ENV, collectionPoint);

  if (!shouldShowRecipeModal) {
    return null;
  }

  const createBrazeUser = async (email, signUpSource) => {
    const { externalId } = await fetch(`/uk/api/marketing/user/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        signUpSource,
      }),
    }).then((res) => res.json());

    return externalId;
  };

  return (
    <ThemeProvider theme={themeNew}>
      <RecipeModal
        delay={delay}
        content={modalContent}
        collectionPoint={collectionPoint}
        consentPurposes={consentPurposes}
        postConsent={postConsent}
        createBrazeUser={createBrazeUser}
        trackBrazeUser={trackBrazeUser}
      />
    </ThemeProvider>
  );
}
